import React, { Component } from 'react'

class DualRing extends Component {
  render() {
    return (
      <div className='list-loader'>
        <div className='lds-dual-ring'></div>
      </div>
    )
  }
}

export default DualRing



// WEBPACK FOOTER //
// ./src/components/DualRing.js